import { CylinderGeometry, Mesh, TorusGeometry } from 'three';
import { RescueTool } from './RescueTool';

export class LifeRing extends RescueTool {
  constructor() {
    super('lifeRing');
    const ring = new Mesh(new TorusGeometry(0.95, 0.27, 10, 24), this.standardMaterial(0xff6b4a));
    ring.rotation.x = Math.PI / 2;
    ring.castShadow = true;
    this.group.add(ring);
    for (let i = 0; i < 4; i += 1) {
      const band = new Mesh(new CylinderGeometry(0.31, 0.31, 0.42, 8), this.standardMaterial(0xfff7e8));
      band.rotation.z = Math.PI / 2;
      band.position.set(Math.cos((i * Math.PI) / 2) * 0.95, 0, Math.sin((i * Math.PI) / 2) * 0.95);
      band.rotation.y = -(i * Math.PI) / 2;
      this.group.add(band);
    }
  }
}
